__turbopack_context__.v({
  "columns": "accountWrapper-module-scss-module__cpkRna__columns",
  "inner": "accountWrapper-module-scss-module__cpkRna__inner",
  "wrapper": "accountWrapper-module-scss-module__cpkRna__wrapper",
});
